import React, { useState, useEffect, useCallback } from "react";
import ClockDisplay from "../../components/ClockDisplay/ClockDisplay";
import FeedbackDisplay from "../../components/FeedbackDisplay/FeedbackDisplay";
import SideMenu from "../../components/SideMenu/SideMenu";
import getRandomPosition from "../../utils/positions";
import Tabs from "../../components/Tabs";

import "../../App.css";
import "./PracticeMode.css";

const defaultClockSettings = {
  showNumbers: true,
  showSmallTicks: true,
  showLargeTicks: true,
  showDigitalTime: false,
};

function PracticeMode() {
  const [targetTime, setTargetTime] = useState(generateRandomTime());
  const [userInput, setUserInput] = useState("");
  const [score, setScore] = useState(0);
  const [attempts, setAttempts] = useState(0);
  const [correctAnswers, setCorrectAnswers] = useState(0);
  const [gameOver, setGameOver] = useState(false);
  const feedbackRef = React.useRef();

  const [clockSettings, setClockSettings] = useState(() => {
    const savedSettings = localStorage.getItem("clockSettings");
    return savedSettings ? JSON.parse(savedSettings) : defaultClockSettings;
  });

  // Persist clockSettings to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem("clockSettings", JSON.stringify(clockSettings));
  }, [clockSettings]);

  function generateRandomTime() {
    const hours = Math.floor(Math.random() * 12) + 1; // 1 to 12
    const minutes = Math.floor(Math.random() * 60);
    return `2024-03-15T${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:00`;
  }

  function formatTimeInput(value) {
    // Remove any non-digit characters
    const digits = value.replace(/\D/g, "");
    if (digits.length <= 2) return digits;
    if (digits.length === 3) {
      return `${digits[0]}:${digits.slice(1)}`;
    }
    return `${digits.slice(0, 2)}:${digits.slice(2, 4)}`;
  }

  function handleInputChange(e) {
    const formattedValue = formatTimeInput(e.target.value);
    setUserInput(formattedValue);
  }

  function handleSubmit() {
    setAttempts(attempts + 1);
    const [hours, minutes] = targetTime.split("T")[1].split(":");
    const correctTime = `${hours}:${minutes}`;
    const normalizeTime = (time) => {
      const [h, m] = time.split(":");
      return `${parseInt(h, 10)}:${parseInt(m, 10)}`;
    };

    const normalizedUserInput = normalizeTime(userInput);
    const normalizedCorrectTime = normalizeTime(correctTime);

    if (normalizedUserInput === normalizedCorrectTime) {
      setScore(score + 1);
      setCorrectAnswers(correctAnswers + 1);
      feedbackRef.current("randomMessage", "Good", correctTime, userInput);
    } else {
      feedbackRef.current(`randomMessage`, "Poor", correctTime, userInput);
    }
    setUserInput("");
    setTargetTime(generateRandomTime());
  }

  function handleRestart() {
    setScore(0);
    setAttempts(0);
    setCorrectAnswers(0);
    setGameOver(false);
    setTargetTime(generateRandomTime());
  }

  const handleFeedbackRef = useCallback((addFeedback) => {
    feedbackRef.current = addFeedback;
  }, []);

  const handleSettingChange = (setting) => {
    setClockSettings((prev) => ({
      ...prev,
      [setting]: !prev[setting],
    }));
  };

  return (
    <div className="PracticeMode-container">
      {/* <div className="timer">Practice Mode </div> */}
      <div class="ClockDisplay">
        <ClockDisplay targetTime={targetTime} settings={clockSettings} />
      </div>
      <FeedbackDisplay ref={handleFeedbackRef} />
      <input
        type="text"
        value={userInput}
        onChange={handleInputChange}
        onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
        placeholder="HH:MM"
        className="time-input"
        disabled={gameOver}
      />
      <SideMenu
        settings={clockSettings}
        onSettingChange={handleSettingChange}
      />
    </div>
  );
}

export default PracticeMode;
